import { mapGetters } from 'vuex'
import orderFinance from '@/modules/mixins/orderFinance'
import { TIER_TIME_OK, TIER_TIME_UNAVAILABLE } from '@/modules/helpers/deliveryPeriodSlots'

export default {
    mixins: [orderFinance],
    props: {
        restaurant: {
            type: Object,
            default: () => {},
        },
        blockLoader: Boolean,
    },
    data() {
        return {
            alertContent: '',
        }
    },
    computed: {
        ...mapGetters({
            activeCurrency: 'active/currency',
            orderRestaurant: 'order/restaurant',
            address: 'order/address',
            time: 'order/time',
            isAsap: 'order/asap',
            allowance: 'allowance',
            smDevice: 'smDevice',
            lgDevice: 'lgDevice',
            cartOpen: 'site/cartOpen',
            deliveryPeriod: 'deliveryPeriod',
            activeCanteen: 'active/canteen',
            activeRestaurant: 'active/restaurant',
            restaurantView: 'site/restaurantView',
            deliveryTimeChanged: 'active/deliveryTimeChanged',
            deliveryFeeChanged: 'active/deliveryFeeChanged',
            appDebug: 'site/appDebug',
            expenseRules: 'expenseRules',
        }),
        cart() {
            return this.$cart
        },
        calculation() {
            return this.cart.temporary || this.cart.calculation
        },
        calculated() {
            return this.cart.calculated
        },
        orderFinanceModel() {
            return this.calculated && this.hasContent ? this.calculation : {}
        },
        isCheckout() {
            return !!this.$route.meta.blockLocation
        },
        usableExpenseRules() {
            return (
                this.expenseRules?.filter(
                    (rule) =>
                        !!this.$cart.calculation.usable_expense_rules?.find(
                            (usableRules) => usableRules.id === rule.id
                        )
                ) || []
            )
        },
        isNotCheckoutPageAndHasAllowance() {
            return !(this.$route.name === 'checkout') && this.usableExpenseRules.length
        },
        errors() {
            return [
                ...(this.calculation.validation_errors || []),
                ...(this.asapBugTemporaryFix &&
                (!this.calculation.validation_errors ||
                    this.calculation.validation_errors.length === 0)
                    ? [
                          {
                              propertyPath: 'requiredDeliveryTime',
                              message: this.$t('cart.time.wrong'),
                          },
                      ]
                    : []),
                // task #155: the chosen scheduled time is no longer offered (tiered restaurant)
                ...(this.tierTimeState === TIER_TIME_UNAVAILABLE &&
                !this.asapBugTemporaryFix &&
                (!this.calculation.validation_errors ||
                    this.calculation.validation_errors.length === 0)
                    ? [
                          {
                              propertyPath: 'requiredDeliveryTime',
                              message: this.$t('cart.time.wrong'),
                          },
                      ]
                    : []),
            ]
        },
        tierTimeState() {
            return this.$store.getters.tierTimeState
        },
        asapBugTemporaryFix() {
            // TODO remove after #894 is resolved
            return (
                this.isAsap && !this.deliveryPeriod.immediate_available && !this.activeCanteen?.id
            )
        },
        currency() {
            return this.activeCurrency.locale
                ? this.activeCurrency
                : this.orderRestaurant.country || {}
        },
        hasContent() {
            return Boolean(
                (this.restaurantIsSet || (this.smDevice && !this.activeRestaurant?.link)) &&
                    this.cart?.items?.length
            )
        },
        restaurantIsSet() {
            return this.orderRestaurant?.link === this.restaurant?.link
        },
        minimumOrder() {
            return this.restaurant.location_info && this.restaurant.location_info.minimum_order
                ? this.restaurant.location_info.minimum_order
                : null
        },
        wrongAddress() {
            return this.errors?.findIndex((error) => error.propertyPath === 'latitude') > -1
        },
        checkoutDisabled() {
            if (this.appDebug)
                // eslint-disable-next-line no-console
                console.debug(
                    `\x1b[34m = = = checkoutDisabled = = =` +
                        `\n\x1b[34m01. \x1b[33m${(
                            this.minimumOrder > this.calculation.price_sum_items
                        )
                            .toString()
                            .toUpperCase()}\x1b[37m - Minimum order price not mached!` +
                        `\n\x1b[34m01. \x1b[33m${(!this.hasContent)
                            .toString()
                            .toUpperCase()}\x1b[37m - Empty cart!` +
                        `\n\x1b[34m01. \x1b[33m${(this.errors?.length !== 0)
                            .toString()
                            .toUpperCase()}\x1b[37m - Has validation errors from \x1b[37;3mcalculate\x1b[37;23m!` +
                        `\n\x1b[34m01. \x1b[33m${(!this.calculated && this.hasContent)
                            .toString()
                            .toUpperCase()}\x1b[37m - Cart has content, but not calculated!` +
                        `\n\x1b[34m01. \x1b[33m${this.deliveryFeeChanged
                            .toString()
                            .toUpperCase()}\x1b[37m - Delivery fee changed!` +
                        `\n\x1b[34m01. \x1b[33m${this.deliveryTimeChanged
                            .toString()
                            .toUpperCase()}\x1b[37m -  Delivery time changed!` +
                        `\n\x1b[34m01. \x1b[33m${this.cart.hasInactiveItem
                            .toString()
                            .toUpperCase()}\x1b[37m -  Cart has inactive item!` +
                        `\n\x1b[34m01. \x1b[33m${this.asapBugTemporaryFix
                            .toString()
                            .toUpperCase()}\x1b[37m -  ASAP selected, but not available! TEMPORARY FIX!` +
                        `\n\x1b[34m01. \x1b[33m${(this.tierTimeState !== TIER_TIME_OK)
                            .toString()
                            .toUpperCase()}\x1b[37m -  Scheduled time not verified for the subtotal (${
                            this.tierTimeState
                        })!`
                )
            return (
                this.minimumOrder > this.calculation.price_sum_items ||
                !this.hasContent ||
                this.errors?.length !== 0 ||
                (!this.calculated && this.hasContent) ||
                this.deliveryFeeChanged ||
                this.deliveryTimeChanged ||
                this.cart.hasInactiveItem ||
                this.asapBugTemporaryFix ||
                this.tierTimeState !== TIER_TIME_OK
            )
        },
        noAddress() {
            return !this.address.full_address
        },
        loading() {
            return this.cart.loading
        },
        longDelay() {
            return this.lgDevice && this.cart.delay && !this.blockLoader
        },
        inactiveItems() {
            return this.cart.inactiveItems
        },
        sortedItems() {
            return this.sortNull(this.calculation.items, 'meal_option_position')
        },
    },
    methods: {
        async setCartItem(item, index) {
            if (
                item.quantity > (item.minimum_quantity > 0 ? item.minimum_quantity - 1 : 0) ||
                (this.cart.meals[index].quantity < item.quantity &&
                    item.quantity < this.calculation.items[index].minimum_quantity)
            )
                this.cart.setMeal(item, index)
            else this.cart.removeMeal(index)
            await this.cart.calculate()
            if (this.isCheckout) await this.cart.autoPaymentMethod()
            this.cart.event('price')
            if (this.cart.hasInactiveItem) this.$refs.inactiveItemsModal.open()
        },
        async goToCheckout() {
            await this.cart.calculate()
            if (this.cart.hasInactiveItem) {
                this.$refs.inactiveItemsModal.open()
                return
            }
            if (this.checkoutDisabled) return

            if (!this.loading) {
                this.$emit('go-to-checkout')
                this.$router.push({ name: 'checkout' }, () => {
                    this.hideCart()
                })
            }
        },
        goToResaurant() {
            if (!this.loading)
                this.$router.push(
                    {
                        name: 'restaurant',
                        params: { slug: this.orderRestaurant.slug },
                    },
                    () => {
                        this.hideCart()
                    }
                )
        },
        hideCart() {
            if (this.smDevice) {
                this.$store.dispatch('site/setCart', false)
                this.$store.dispatch('blockScroll', false)
            }
        },
        hideError(error) {
            return ['items.meal'].includes(error.propertyPath?.replace(/\[\d\]/, ''))
        },
        getErrorIcon(error) {
            switch (error.propertyPath) {
                case 'latitude':
                    return 'fa-solid fa-map-marker-alt'
                case 'requiredDeliveryTime':
                    return 'fa-solid fa-clock'
                case 'restaurant':
                    return 'fa-solid fa-utensils'
                default:
                    return 'fa-solid fa-utensils'
            }
        },
        getErrorText(error) {
            switch (error.propertyPath) {
                case 'latitude':
                    if (this.noAddress) return this.$t(`cart.location.missing`)
                    return error.message
                case 'requiredDeliveryTime':
                    return this.$t(`cart.time.wrong`)
                default:
                    return error.message
            }
        },
        getErrorButtonEvent(error) {
            switch (error.propertyPath) {
                case 'latitude':
                    return this.$user.isLoggedIn
                        ? this.$location.select.open
                        : this.$location.enter.open
                case 'requiredDeliveryTime':
                    return this.$time.open
                case 'groupOrderEmployees':
                    return this.$cart.resetGroupOrder
                default:
                    return undefined
            }
        },
        getErrorButtonText(error) {
            switch (error.propertyPath) {
                case 'latitude':
                    if (this.noAddress) return this.$t('cart.location.add')
                    return this.$t('cart.location.change')
                case 'requiredDeliveryTime':
                    return this.$t('cart.time.change')
                case 'groupOrderEmployees':
                    return this.$t('cart.group_order.clear')
                default:
                    return undefined
            }
        },
    },
}
